import { render } from "./formularioPreregistro.vue?vue&type=template&id=2001d3f0"
import script from "./formularioPreregistro.vue?vue&type=script&lang=js"
export * from "./formularioPreregistro.vue?vue&type=script&lang=js"

import "./formularioPreregistro.vue?vue&type=style&index=0&id=2001d3f0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__